const flightDocumentParser = {
    "passport": "Passport", 
    "tax_id": "Tax Identification Number", 
    "known_traveler_number": "Known Traveler Number", 
    "passenger_redress_number": "Passenger Redress Number" 
};

module.exports = {
    flightDocumentParser
};